

// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css/bundle';



(function($) { "use strict";


	// Quotes carousel - homepage
	const swiper = new Swiper('.quotes-carousel', {

		// Optional parameters
		// loop: true,

		slidesPerView: 'auto',

		slidesPerGroup: 2,

		slidesOffsetAfter: 100,
		
		mousewheel: {
			enabled: true,
			forceToAxis: true,
			releaseOnEdges: true,
		},
	
		spaceBetween: 22,

		freeMode: {
			enabled: true,
			sticky: false,
		},
	
		// Navigation arrows
		navigation: {
		  nextEl: '.quotes-carousel__controls .next',
		  prevEl: '.quotes-carousel__controls .prev',
		},

		breakpoints: {
			1: {
				slidesPerGroup: 1,
				slidesOffsetAfter: 520,
			},
			501: {
				slidesPerGroup: 1,
				slidesOffsetAfter: 430,
			},
			1001: {
				slidesOffsetAfter: 200,
			},
			1501: {
				slidesOffsetAfter: 400,
			},
			2001: {
				slidesOffsetAfter: 700,
			},
		}

	});



	// Basic carousel - Country map items
	const basicCarousel = new Swiper('.basic-carousel', {

		
		loop: true,

		effect: 'fade',
		fadeEffect: {
		  crossFade: true,
		},

		autoplay: {
			delay: 4000,
		},

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable:'true'
		},


	});




})(jQuery);
